import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const ADMIN_APPROVAL_SERVER = ConfigurationService.get(ConfigurationKeys.ADMIN_APPROVAL_SERVER);
const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

export const ACCOUNT_URL = `${ADMIN_APPROVAL_SERVER}/rest/v1/accounts`;
export const ACCOUNT_IDENTITY_BASE_URL = `${ADMIN_APPROVAL_SERVER}/rest/v2/accounts`;
export const ACCOUNT_IDENTITY_IMAGE_BASE_URL = ACCOUNT_URL;
export const ACCOUNT_PERMISSION_URL = `${ACCOUNT_URL}/access`;
export const CASHOUT_IDENTITIES_URL = `${ADMIN_APPROVAL_SERVER}/rest/v1/cash-out-approval-accounts`;
export const IDENTITIES_URL = `${ADMIN_APPROVAL_SERVER}/rest/v4/identities`;
export const CONVERSATIONS_URL = `${BASE_URL}/loadConversations`;
export const SECURITY_LOG_URL = `${BASE_URL}/rest/v1.0/security-logs`;
export const SPAM_MESSAGES_URL = `${BASE_URL}/rest/v1.0/spam-messages`;
export const SPAM_MESSAGES_SUMMARY_URL = `${BASE_URL}/rest/v1.0/spam-messages-summary`;
export const SPAM_MESSAGES_USER_SUMMARY_URL = `${BASE_URL}/rest/v1.0/spam-messages-user-summary`;
export const SPAM_MESSAGES_SCORE_URL = `${BASE_URL}/rest/v1.0/spam-messages/score`;
export const SPAM_MESSAGES_IP_SUMMARY = `${BASE_URL}/rest/v1.0/spam-messages-ip-summary`;
export const SPAM_MESSAGES_RECIPIENT_SUMMARY = `${BASE_URL}/rest/v1.0/spam-messages-recipient-summary`;
export const TOTAL_COUNTS_IDENTITIES_URL = `${IDENTITIES_URL}/count`;
export const TOTAL_COUNTS_CASHOUT_URL = `${CASHOUT_IDENTITIES_URL}/count`;
export const WATCHLIST_TOTAL_COUNT_URL = `${IDENTITIES_URL}/watchlist/count`;
export const WATCHLIST_URL = `${IDENTITIES_URL}/watchlist`;

export const GET_ACCOUNT_IDENTITY_URL = (accUsername, type) =>
  `${ACCOUNT_IDENTITY_BASE_URL}/${accUsername}/identities/${type}`;

export const GET_ACCOUNT_IDENTITY_IMAGES_URL = (accUsername, type, imageType) =>
  `${ACCOUNT_IDENTITY_IMAGE_BASE_URL}/${accUsername}/identities/${type}/images/${imageType}`;

export const GET_ADDITIONAL_IDENTITIES_URL = (accUsername) =>
  `${ACCOUNT_IDENTITY_BASE_URL}/${accUsername}/identities`;

export const GET_CASHOUT_IDENTITY_STATUS_URL = (username) =>
  `${BASE_URL}/rest/v1.0/user-paypal-statuses/${username}`;

export const GET_CASHOUT_UPDATE_IDENTITY_URL = (username) =>
  `${CASHOUT_IDENTITIES_URL}/${username}`;

export const GET_DIRECTORY_ADMIN_APPROVAL_URL = (username) =>
  `${ADMIN_APPROVAL_SERVER}/rest/v4/identities/count-custom?usernames=${username}&accountStatus=APPROVED`;

export const getEditFullNameUrl = (username, identity) =>
  `${ADMIN_APPROVAL_SERVER}/rest/v2/accounts/${username}/identities/${identity}`;

export const GET_GALLERY_IMAGES_URL = (accUsername) =>
  `${BASE_URL}/rest/v1.0/snapshots/${accUsername}`;

export const GET_IDENTITIES_MATCHING_URL = (usernameList) =>
  `${IDENTITIES_URL}/matching?usernameList=${usernameList}`;

export const GET_REMOVE_PERFORMER_URL = (studioOwnerName, performerName) =>
  `${BASE_URL}/rest/v1.0/studio/${studioOwnerName}/roster/${performerName}`;

export const GET_REMOVE_SECURITY_LOG_URL = (logId) =>
  `${BASE_URL}/rest/v1.0/security-logs/${logId}`;

export const GET_ROSTER_URL = (studioOwnerName) =>
  `${BASE_URL}/rest/v1.0/studio/${studioOwnerName}/roster`;

export const GET_STAFF_NOTES_URL = (accountHolderUsername) =>
  `${ACCOUNT_URL}/${accountHolderUsername}/notes`;

export const GET_UPDATE_ACCOUNT_URL = (accUsername) =>
  `${ACCOUNT_URL}/${accUsername}`;
